/* global femcare */

femcare.tracking.analyticsEvents = {
    init: function() {
        var analyticsCookie = this.getCookie('AnalyticsEvents');

        if (typeof dataLayer !== 'undefined' && analyticsCookie) {
            var analyticsEvents = JSON.parse(analyticsCookie);

            for (var index = 0; index < analyticsEvents.length; index++) {
                window.dataLayer.push(analyticsEvents[index]);
            }

            this.deleteCookie('AnalyticsEvents');
        }
    },

    deleteCookie: function(name) {
        document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    getCookie: function(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift();
        }
    }
};
